import { useEffect, useState } from 'react'
import cx from 'classnames'
import styles from './ConfiguratorThemeOptions.module.scss'
import NoImage from '../../../assets/images/NoImage.png'
import { fetchMoreOptions } from '../../../helpers/viewerHelper'
import InfiniteScroll from '../../InfiniteScroll/InfiniteScroll'
import { useDispatch } from 'react-redux'

export const ConfiguratorThemeOptions = ({
  selectedList,
  allLabels,
  allScenes,
  scenePassed,
  pressedBackBtn,
  profileData,
  selectedProfile,
  selectProfile,
  setNewScene,
  setNewLabels,
  listLabels,
  setNewList,
  selectLayout,
  setLabel,
  localLayoutData,
  localProfileData,
  selectedLayoutData,
  selectedProfileData,
  selectedDripTrayStyle,
  localDipTrayStyle,
  selectDripTrayStyle,
  localBracketData,
  localEndCapData,
  localElbowData,
  selectedBracketData,
  selectedEndcapData,
  selectedElbowData,
  selectBracket,
  selectEndcap,
  selectElbow,
  setSelectedFinishType,
  selectedFinishType,
  loading,
  showSizeBtn = false,
  showSubLabel = false,
  // setShowThumbnail = () => {},
  setZoom,
}) => {
  const [optionsToShow, setOptionsToShow] = useState([])
  const [selectedOption, setSelectedOption] = useState()
  const [labelNextPage, setLabelNextPage] = useState()

  useEffect(() => {
    const selectedOptionList = [
      'Finish',
      'Countertop Finish',
      'Frame',
      'Upholstery',
      'Upholstery Fabric',
      'Wood Finish',
      'Paint Color',
      'Wood Top',
    ]
    if (
      (!selectedFinishType?.name &&
        selectedOptionList.includes(selectedList)) ||
      (selectedOptionList.includes(selectedList) &&
        selectedOption?.name !== selectedFinishType?.name)
    ) {
      setSelectedFinishType?.({
        ...selectedFinishType,
        [selectedList]: selectedOption,
      })
    }
  }, [selectedOption, selectedList])

  const dispatch = useDispatch()
  let apiUsed = null
  let options

  useEffect(() => {
    if (selectedList === 'layout') {
      setOptionsToShow(localLayoutData)
      setSelectedOption(selectedLayoutData)
      if (scenePassed?.id) {
        const opSelected = localLayoutData.find(
          (sc) => sc.id === selectedLayoutData.id
        )
        if (opSelected?.id) {
          setSelectedOption(opSelected)
        }
      }
    } else if (selectedList === 'profile') {
      setOptionsToShow(localProfileData)
      setSelectedOption(selectedProfileData)
    } else if (selectedList === 'dripStyle') {
      setOptionsToShow(localDipTrayStyle)
      setSelectedOption(selectedDripTrayStyle)
    } else if (selectedList === 'bracket') {
      setOptionsToShow(localBracketData)
      setSelectedOption(selectedBracketData)
    } else if (selectedList === 'endcap') {
      setOptionsToShow(localEndCapData)
      setSelectedOption(selectedEndcapData)
    } else if (selectedList === 'elbow') {
      setOptionsToShow(localElbowData)
      setSelectedOption(selectedElbowData)
    } else {
      for (let i = 0; i < allLabels?.length; i++) {
        if (allLabels?.[i]?.name === selectedList) {
          setOptionsToShow(allLabels[i].textures)
          checkForSelectedOptionInLabel(allLabels[i])
          break
        }
      }
    }
  }, [
    selectedList,
    allLabels,
    allScenes,
    scenePassed,
    pressedBackBtn,
    profileData,
    selectedProfile,
    selectedDripTrayStyle,
    localBracketData,
    localEndCapData,
    localElbowData,
    selectedBracketData,
    selectedEndcapData,
    selectedElbowData,
  ])

  const checkForSelectedOptionInLabel = (labelData) => {
    let currentLabel = labelData
    if (currentLabel.selectedTexture) {
      setSelectedOption(currentLabel.selectedTexture)
    } else if (currentLabel?.textures?.length) {
      setSelectedOption(currentLabel?.textures[0])
    }
  }

  const selectCurrentOption = (e, data) => {
    setZoom(false)
    e?.stopPropagation()
    if (loading) {
      return
    }
    // if (showSubLabel) {
    //   setShowThumbnail(data)
    // } else {
    //   setShowThumbnail(null)
    // }
    if (selectedList === 'layout') {
      selectLayout(data)
    } else if (selectedList === 'profile') {
      selectProfile(data)
    } else if (selectedList === 'dripStyle') {
      selectDripTrayStyle(data)
    } else if (selectedList === 'bracket') {
      selectBracket(data)
    } else if (selectedList === 'endcap') {
      selectEndcap(data)
    } else if (selectedList === 'elbow') {
      selectElbow(data)
    } else {
      let labelData
      for (let i = 0; i < allLabels?.length; i++) {
        if (selectedList === allLabels[i].name) {
          labelData = allLabels[i]
          break
        }
      }
      setNewLabels({ option: data, label: labelData?.id })
    }
  }

  const checkIfSelected = (data) => {
    const flag = selectedOption?.id === data?.id
    return flag
  }

  const getOptionImage = (opData) => {
    return (
      <>
        {!opData?.thumb && opData?.color_code ? (
          <div className={styles.imgContainer}>
            <div
              style={{
                background: opData.color_code,
                aspectRatio: '4/4',
                borderRadius: 4,
              }}
            ></div>
          </div>
        ) : (
          <img
            src={opData.thumb}
            className={styles.opImg}
            alt="img"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null // prevents looping
              currentTarget.src = NoImage
            }}
          />
        )}
      </>
    )
  }

  const fetchMoreData = () => {
    let labelData = allLabels.find((lb) => selectedList === lb.name)
    fetchMoreOptions(
      labelNextPage,
      dispatch,
      labelData,
      allLabels,
      setLabel,
      options,
      null,
      apiUsed,
      true
    )
  }

  // const leatherFinishId = [148109,148108,148111,148110,148105,148112,148110,148111,148108, 148109];
  // const fabricFinishId = [148113,148117,148114,148115,148116,
  //   149105, 149110, 149101, 149107, 149104, 149106, 149070, 149109, 149111,
  //   149113, 149114, 149115, 149071, 149072, 149116, 149073, 149074, 149075,
  //   149076, 149078, 149079, 149080, 149081, 149082, 149083, 149084, 148834,
  //   148856, 148835, 148833, 148836, 148837, 148817, 148818, 149085, 149119,
  //   149120, 149086, 149087, 149088, 149089, 149090, 149091, 149092, 149121,
  //   149122, 149095, 149096, 149102, 149117, 148840, 149097, 149103, 148839,
  //   148838, 148841, 149118, 149077, 149093, 149094, 149098, 149100, 149099,
  //   149123, 149124, 149108, 149112, 148819, 148820, 148842, 148843, 148821,
  //   148822, 148844, 148823, 148824, 148845, 148825, 148826, 148827, 148846,
  //   148847, 148848, 148849, 148850, 148851, 148828, 148829, 148852, 148830,
  //   148853, 148831, 148832, 148854, 148855,
  // ];

  return (
    <div>
      <InfiniteScroll
        dataLength={optionsToShow?.length}
        next={() => fetchMoreData()}
        hasMore={labelNextPage}
        loading={false}
        containerClassName="configurator-infinte-scroll-min-height-auto"
        hasChildren={true}
        loadingType={null}
        scrollableTarget="infinteScroll-previewpage-side-label-options"
      >
        <div className={styles.optionList}>
          {!!optionsToShow?.length &&
            optionsToShow.map((opData, index) => {
              if (showSizeBtn) {
                return (
                  <div
                    className={cx(
                      styles.labelBtnOption,
                      checkIfSelected(opData) && styles.btnSelected,
                      'mb-1'
                    )}
                    key={index}
                    onClick={(e) =>
                      !checkIfSelected(opData) && selectCurrentOption(e, opData)
                    }
                  >
                    <div
                      className={styles.btnTextContainer}
                      title={opData.name || opData.display_name}
                    >
                      <div className={styles.btnTileName}>
                        {opData.name || opData.display_name}
                      </div>
                    </div>
                  </div>
                )
              } else {
                return (
                  <div
                    className={cx(
                      styles.labelOption,
                      checkIfSelected(opData) && styles.selected
                    )}
                    key={index}
                    onClick={(e) =>
                      !checkIfSelected(opData) && selectCurrentOption(e, opData)
                    }
                  >
                    {getOptionImage(opData)}
                    <div
                      className={styles.textContainer}
                      title={opData.name || opData.display_name}
                    >
                      <div className={styles.tileName}>
                        {opData.name || opData.display_name}
                      </div>
                    </div>
                  </div>
                )
              }
            })}
        </div>
        {/* {showSubLabel ? (
          <>
             <div className={styles?.subTitle}>Leather Finishes</div>
            <div className={styles.optionList}>
              {!!optionsToShow?.length &&
                optionsToShow.map((opData, index) => {
                  if(!leatherFinishId?.includes(opData?.id)){
                    return null;
                  }
                  return (
                    <div
                      className={cx(
                        styles.labelOption,
                        checkIfSelected(opData) && styles.selected
                      )}
                      key={index}
                      onClick={(e) => !checkIfSelected(opData) && selectCurrentOption(e, opData)}
                    >
                      {getOptionImage(opData)}
                      <div
                        className={styles.textContainer}
                        title={opData.name || opData.display_name}
                      >
                        <div className={styles.tileName}>
                          {opData.name || opData.display_name}
                        </div>
                      </div>
                    </div>
                  )
                })}
            </div> 
             <div className={styles?.subTitle}>Fabric Finishes</div>
            <div className={styles.optionList}>
              {!!optionsToShow?.length &&
                optionsToShow.map((opData, index) => {
                  if(!fabricFinishId?.includes(opData?.id)){
                    return null;
                  }
                  return (
                    <div
                      className={cx(
                        styles.labelOption,
                        checkIfSelected(opData) && styles.selected
                      )}
                      key={index}
                      onClick={(e) => !checkIfSelected(opData) && selectCurrentOption(e, opData)}
                    >
                      {getOptionImage(opData)}
                      <div
                        className={styles.textContainer}
                        title={opData.name || opData.display_name}
                      >
                        <div className={styles.tileName}>
                          {opData.name || opData.display_name}
                        </div>
                      </div>
                    </div>
                  )
                })}
            </div> 
          </>
        ) : (
            <div className={styles.optionList}>
              {!!optionsToShow?.length &&
                optionsToShow.map((opData, index) => {
                  if (showSizeBtn) {
                    return (
                      <div
                        className={cx(
                          styles.labelBtnOption,
                          checkIfSelected(opData) && styles.btnSelected
                        )}
                        key={index}
                        onClick={(e) => !checkIfSelected(opData) && selectCurrentOption(e, opData)}
                      >
                        <div
                          className={styles.btnTextContainer}
                          title={opData.name || opData.display_name}
                        >
                          <div className={styles.btnTileName}>
                            {opData.name || opData.display_name}
                          </div>
                        </div>
                      </div>
                    )
                  } else {
                    return (
                      <div
                        className={cx(
                          styles.labelOption,
                          checkIfSelected(opData) && styles.selected
                        )}
                        key={index}
                        onClick={(e) => !checkIfSelected(opData) && selectCurrentOption(e, opData)}
                      >
                        {getOptionImage(opData)}
                        <div
                          className={styles.textContainer}
                          title={opData.name || opData.display_name}
                        >
                          <div className={styles.tileName}>
                            {opData.name || opData.display_name}
                          </div>
                        </div>
                      </div>
                    )
                  }
                })}
            </div>
    
        )} */}
      </InfiniteScroll>
    </div>
  )
}
